// @ts-strict-ignore
import { useInternalWholesaleCartsQuery } from "@shared/data/queries/InternalWholesaleCartsQuery/InternalWholesaleCarts.query";

import { CartBody } from "./CartBody/CartBody";
import { SkeletonCart } from "./SkeletonCart/SkeletonCart";

import * as styles from "./MultiCartPopup.styles";

interface Props {
  setCartToRemove: (orderId: string) => void;
}

const MultiCartPopup = (props: Props) => {
  const { data: internalWholesaleCartsData, loading: loadingInternalWholesaleCarts } =
    useInternalWholesaleCartsQuery({
      fetchPolicy: "cache-and-network",
    });

  const renderCartBody = () => {
    if (loadingInternalWholesaleCarts) return <SkeletonCart />;

    return <CartBody {...props} internalWholesaleCartsData={internalWholesaleCartsData} />;
  };

  return (
    <div data-testid="multi-cart-body" css={styles.cartPopup}>
      {renderCartBody()}
    </div>
  );
};

export { MultiCartPopup };
